import AsyncState from "react-async-stateful";

import * as UserSelectors from "../User/User.selector";
import * as FleetSelectors from "../Fleet/Fleet.selector";
import * as GroupUtils from "../../lib/util/GroupUtils";

import { asyncStateProxy, createSelector } from "../../lib/util/ReduxUtils";
import { selectLoggedInUserGroupId } from "../User/User.selector";
import { selectCurrentScopeFleetGroups } from "../Fleet/Fleet.selector";
import { StoreState } from "../RootReducer";
import { Group } from "../../lib/types/Group";
import { isManagerOrBelow } from "../../lib/util/AuthUtils";
import { isDemoModeEnabled } from "../Global/Global.selector";

export const selectIsCurrentScopeDriverless = createSelector(
	[
		FleetSelectors.selectCurrentScopeFleet,
		UserSelectors.selectIsCurrentScopeFleetOutsider,
	],
	(fleet, guestMode) => (fleet.value && fleet.value.driverless) || guestMode,
);

export const selectCurrentScopeGroupsAvailableToUser = (
	state: StoreState,
): AsyncState<Group[]> => {
	return asyncStateProxy(selectCurrentScopeFleetGroups(state), (allGroups) => {
		const userGroup = selectLoggedInUserGroupId(state);
		const scoped = userGroup && isManagerOrBelow() && !isDemoModeEnabled(state);
		const scopedGroup =
			scoped && GroupUtils.findGroupById(allGroups as any, userGroup);

		return scoped && scopedGroup ? [scopedGroup] : allGroups;
	}) as any;
};
